import { render } from "./pnc_full_head.vue?vue&type=template&id=58296b90&scoped=true"
import script from "./pnc_full_head.vue?vue&type=script&lang=js"
export * from "./pnc_full_head.vue?vue&type=script&lang=js"

import "./pnc_full_head.vue?vue&type=style&index=0&id=58296b90&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58296b90"]])

export default __exports__